<template>
  <!-- Every colour and the optional background image come from the token layer
       (useThemeTokens.js): the chrome tokens + --bg-image-footer. -->
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-links">
        <button type="button" class="footer-link" @click="showImpressum">{{ $t('footer.impressum') }}</button>
        <span class="separator" aria-hidden="true">|</span>
        <button type="button" class="footer-link" @click="showDataProtection">{{ $t('footer.dataProtection') }}</button>
        <span class="separator" aria-hidden="true">|</span>
        <button type="button" class="footer-link" @click="showTerms">{{ $t('footer.terms') }}</button>
      </div>
      <div class="footer-copyright">
        <p>&copy; {{ currentYear }} <span v-if="businessOwner">{{ businessOwner }}. </span>{{ $t('footer.rights') }}</p>
        <p class="powered-by">
          <a href="https://www.zabaiherz.com" target="_blank" rel="noopener noreferrer">{{ $t('footer.poweredBy') }} zabaiherz.com</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { useBusinessSettings } from '@/composables/useBusinessSettings'

export default {
  name: 'AppFooter',
  emits: ['show-impressum', 'show-data-protection', 'show-terms'],
  setup() {
    // Address / contact / hours moved to VisitUsSection; only the owner name
    // (used in the copyright line) is still read here.
    const { businessOwner } = useBusinessSettings()
    return { businessOwner }
  },
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  methods: {
    showImpressum() {
      this.$emit('show-impressum')
    },
    showDataProtection() {
      this.$emit('show-data-protection')
    },
    showTerms() {
      this.$emit('show-terms')
    }
  }
}
</script>

<style scoped>
.footer {
  color: var(--chrome-text);
  background-image: var(--bg-image-footer, none), var(--gradient-chrome);
  background-size: cover, cover;
  background-position: center, center;
  background-repeat: no-repeat, no-repeat;
  background-blend-mode: overlay;
  padding: var(--s-5) var(--gutter) var(--s-4);
  margin-top: var(--s-6);
  /* Upward offset composed from the colour-only token (Header.vue composes
     the downward one), so both bars share one shadow colour. */
  box-shadow: 0 -4px 12px var(--chrome-shadow-color);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
}

.footer-link {
  min-height: 44px;
  padding: 12px 8px;
  background: none;
  border: none;
  color: var(--chrome-link);
  font-family: inherit;
  font-size: 1rem;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: var(--chrome-link-hover);
  text-decoration: underline;
}

.footer-link:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

.separator {
  color: var(--chrome-text);
}

.footer-copyright {
  margin-top: var(--s-3);
  padding-top: var(--s-3);
  border-top: 1px solid var(--border-main);
}

.footer-copyright p {
  margin: 0;
  color: var(--chrome-text);
  font-size: 0.9rem;
}

.powered-by {
  margin-top: 0.5rem !important;
  font-size: 0.75rem !important;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.powered-by a {
  color: var(--chrome-text);
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.powered-by:hover {
  opacity: 0.8;
}

.powered-by a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .footer {
    padding-bottom: calc(72px + env(safe-area-inset-bottom));
  }

  .footer-links {
    gap: 0.25rem 0.5rem;
  }

  .separator {
    display: none;
  }
}
</style>
